<template>
    <div class="ui-loading-wrap" v-if="open" ref="msgbox">
        <div class="ui-loading-spinner">
          <i class="iconfont iconLoading"></i>
          <span class="text">{{msg}}</span>
        </div>
    </div>
</template>

<script>
export default {
  props: {
    open: {
      type: Boolean,
      default: true
    },
    msg: {
      type: String,
      default: ''
    }
  },
  mounted () {
    document.body.appendChild(this.$refs.msgbox)
  },
  created () {

  }
}
</script>

<style lang="scss" scoped>
.ui-loading-wrap {
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
  background:rgba(0,0,0,.4);
  .iconLoading{
    width: 40px;
    height: 40px;
    font-size: 40px;
    color: #fff;
    animation: rotatal 1.4s infinite linear;
    animation-fill-mode: both;
    display: block;
    text-align: center;
    line-height: 40px;
    margin:0 auto 10px;
  }
}
@keyframes rotatal {
  from {
    transform: rotate(0);
  } to {
    transform:rotate(360deg);
  }
}
</style>
